/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { useCallback } from 'fierry/react.old/native';

import TextButton from 'fierry/react.old/modern/button/text';
import IconButton from 'fierry/react.old/modern/button/icon';

import withTooltip from 'fierry/react.old/modern/with.tooltip';


const OnClickShallow = (event, onClick) =>
{
  if (onClick)
  {
    onClick(event);
  }

  event.stopPropagation();
}


export default withTooltip( ({ label, onClick, ...props }) =>
{
  const onClickShallow = useCallback(OnClickShallow, [ onClick ]);

  return label ? <TextButton {...props} label = {label} onClick = {onClickShallow} /> : <IconButton {...props} onClick = {onClickShallow} />;
})
